export type TamanhoSummary = {
  tamanhoUL: string;
  totalCnpjs: number;
};

export type TamanhoChange = {
  cnpjLojista: string;
  razaoSocial: string;
  nomeFantasia: string;
  valorAnterior: string;
  valorNovo: string;
};

export type HistoryEntry = {
  id: string;
  date: string;
  user: string;
  changes: TamanhoChange[];
};

export const TAMANHO_UL_OPTIONS = [
  'Não Informado',
  'Numérica A',
  'Numérica B',
  'Numérica C',
  'Outros',
  'Ponderadas A',
  'Ponderadas B',
] as const;

export const TAMANHO_UL_DROPDOWN_OPTIONS = [
  'Não Informado',
  'Numérica A',
  'Numérica B',
  'Numérica C',
  'Outros',
  'Ponderadas A',
  'Ponderadas B',
] as const;

export type ImportRow = {
  cnpjLojista: string;
  tamanhoUL: string;
  valid: boolean;
  reason?: string;
};

export type ImportSummary = {
  tamanhoUL: string;
  count: number;
};

export type ErrorSummary = {
  reason: string;
  count: number;
};

export type ParseProgress = {
  phase: 'reading' | 'validating' | 'done';
  processed: number;
  total: number;
};

export type ParseResult = {
  totalRows: number;
  validCount: number;
  invalidCount: number;
  tamanhoSummary: ImportSummary[];
  errorSummary: ErrorSummary[];
  validItems: { cnpjlojista: string; tamanho_ul: string }[];
};

export type Lojista = {
  CNPJLojista: string;
  RazaoSocial: string;
  NomeFantasia: string;
  tamanho_ul: string;
};

export type Pagination = {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
};

export type LojistasResponse = {
  success: boolean;
  data: Lojista[];
  pagination: Pagination;
};
